import type { Idioma } from '@tallerya/i18n';

/** Uno por idioma: armar un `Intl.NumberFormat` por celda sería caro en una tabla larga. */
const FORMATOS = new Map<Idioma, Intl.NumberFormat>();

function formato(idioma: Idioma): Intl.NumberFormat {
  let f = FORMATOS.get(idioma);
  if (!f) {
    f = new Intl.NumberFormat(idioma, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    FORMATOS.set(idioma, f);
  }
  return f;
}

/**
 * La duración de referencia como la muestra la tabla: en **horas**, con dos
 * decimales fijos (#112).
 *
 * La API la manda en minutos, como se guarda (`referenceDurationMinutes`), y no
 * redondea por nadie: la conversión es de la pantalla. Dos decimales fijos como
 * el Figma —`0.50 h`, `1.50 h`, `2.00 h`— para que la columna se alinee; 20
 * minutos salen `0.33 h`.
 *
 * El separador decimal es el del idioma (`1,50 h` en español de algunas
 * regiones), como todo número del sitio. Sin duración —un producto, o cero, que
 * el dominio no permite pero un dato viejo podría traer— es `—`, el mismo guion
 * que usa el resto de la tabla para «no tiene».
 */
export function horas(minutos: number | null | undefined, idioma: Idioma): string {
  if (!minutos) return '—';

  return `${formato(idioma).format(minutos / 60)} h`;
}
